import axios from "axios";

const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// On a linked custom domain the same app serves /api — stay same-origin so login cookies stay first-party
const sameOrigin = (() => {
  try { return new URL(ENV_BACKEND_URL).origin === window.location.origin; } catch { return true; }
})();
export const BACKEND_URL = sameOrigin || window.location.hostname === "localhost" ? ENV_BACKEND_URL : window.location.origin;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Renew the 60-min session from the 7-day refresh cookie on 401, then retry once
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    if (error.response?.status !== 401 || cfg._retried || /\/auth\/(login|refresh)/.test(url)) {
      return Promise.reject(error);
    }
    cfg._retried = true;
    refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
    try {
      await refreshing;
    } catch (e) {
      if (!url.includes("/auth/me") && window.location.pathname !== "/login") window.location.assign("/login");
      return Promise.reject(error);
    }
    return api(cfg);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
